// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitlistOutreachPreviewRouteImport } from './routes/waitlist-outreach-preview'
import { Route as WaitlistEmailPreviewRouteImport } from './routes/waitlist-email-preview'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as SurveyRouteImport } from './routes/survey'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as InvitesRouteImport } from './routes/invites'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as CliAuthRouteImport } from './routes/cli-auth'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ClaimClaimTokenRouteImport } from './routes/claim/$claimToken'
import { Route as AuthedOrgSlugRouteImport } from './routes/_authed/$orgSlug'
import { Route as AuthedOrgSlugIndexRouteImport } from './routes/_authed/$orgSlug.index'
import { Route as AuthedOrgSlugSettingsRouteImport } from './routes/_authed/$orgSlug.settings'
import { Route as AuthedOrgSlugPullRequestsRouteImport } from './routes/_authed/$orgSlug.pull-requests'
import { Route as AuthedOrgSlugMcpRouteImport } from './routes/_authed/$orgSlug.mcp'
import { Route as AuthedOrgSlugGovernanceRouteImport } from './routes/_authed/$orgSlug.governance'
import { Route as AuthedOrgSlugFindingsRouteImport } from './routes/_authed/$orgSlug.findings'
import { Route as AuthedOrgSlugDashboardRouteImport } from './routes/_authed/$orgSlug.dashboard'
import { Route as AuthedOrgSlugAuditLogRouteImport } from './routes/_authed/$orgSlug.audit-log'

const WaitlistOutreachPreviewRoute = WaitlistOutreachPreviewRouteImport.update({
            id: '/waitlist-outreach-preview',path: '/waitlist-outreach-preview',getParentRoute: () => rootRouteImport
          })
const WaitlistEmailPreviewRoute = WaitlistEmailPreviewRouteImport.update({
            id: '/waitlist-email-preview',path: '/waitlist-email-preview',getParentRoute: () => rootRouteImport
          })
const WaitlistRoute = WaitlistRouteImport.update({
            id: '/waitlist',path: '/waitlist',getParentRoute: () => rootRouteImport
          })
const SurveyRoute = SurveyRouteImport.update({
            id: '/survey',path: '/survey',getParentRoute: () => rootRouteImport
          })
const SsoCallbackRoute = SsoCallbackRouteImport.update({
            id: '/sso-callback',path: '/sso-callback',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const InvitesRoute = InvitesRouteImport.update({
            id: '/invites',path: '/invites',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const CliAuthRoute = CliAuthRouteImport.update({
            id: '/cli-auth',path: '/cli-auth',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ClaimClaimTokenRoute = ClaimClaimTokenRouteImport.update({
            id: '/claim/$claimToken',path: '/claim/$claimToken',getParentRoute: () => rootRouteImport
          })
const AuthedOrgSlugRoute = AuthedOrgSlugRouteImport.update({
            id: '/$orgSlug',path: '/$orgSlug',getParentRoute: () => AuthedRoute
          })
const AuthedOrgSlugIndexRoute = AuthedOrgSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedOrgSlugRoute
          })
const AuthedOrgSlugSettingsRoute = AuthedOrgSlugSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthedOrgSlugRoute
          })
const AuthedOrgSlugPullRequestsRoute = AuthedOrgSlugPullRequestsRouteImport.update({
            id: '/pull-requests',path: '/pull-requests',getParentRoute: () => AuthedOrgSlugRoute
          })
const AuthedOrgSlugMcpRoute = AuthedOrgSlugMcpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => AuthedOrgSlugRoute
          })
const AuthedOrgSlugGovernanceRoute = AuthedOrgSlugGovernanceRouteImport.update({
            id: '/governance',path: '/governance',getParentRoute: () => AuthedOrgSlugRoute
          })
const AuthedOrgSlugFindingsRoute = AuthedOrgSlugFindingsRouteImport.update({
            id: '/findings',path: '/findings',getParentRoute: () => AuthedOrgSlugRoute
          })
const AuthedOrgSlugDashboardRoute = AuthedOrgSlugDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthedOrgSlugRoute
          })
const AuthedOrgSlugAuditLogRoute = AuthedOrgSlugAuditLogRouteImport.update({
            id: '/audit-log',path: '/audit-log',getParentRoute: () => AuthedOrgSlugRoute
          })





const AuthedOrgSlugRouteChildren = {
  AuthedOrgSlugAuditLogRoute: AuthedOrgSlugAuditLogRoute,AuthedOrgSlugDashboardRoute: AuthedOrgSlugDashboardRoute,AuthedOrgSlugFindingsRoute: AuthedOrgSlugFindingsRoute,AuthedOrgSlugGovernanceRoute: AuthedOrgSlugGovernanceRoute,AuthedOrgSlugMcpRoute: AuthedOrgSlugMcpRoute,AuthedOrgSlugPullRequestsRoute: AuthedOrgSlugPullRequestsRoute,AuthedOrgSlugSettingsRoute: AuthedOrgSlugSettingsRoute,AuthedOrgSlugIndexRoute: AuthedOrgSlugIndexRoute
}

const AuthedOrgSlugRouteWithChildren = AuthedOrgSlugRoute._addFileChildren(AuthedOrgSlugRouteChildren)



const AuthedRouteChildren = {
  AuthedOrgSlugRoute: AuthedOrgSlugRouteWithChildren
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,CliAuthRoute: CliAuthRoute,DemoRoute: DemoRoute,InvitesRoute: InvitesRoute,OnboardingRoute: OnboardingRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,SsoCallbackRoute: SsoCallbackRoute,SurveyRoute: SurveyRoute,WaitlistRoute: WaitlistRoute,WaitlistEmailPreviewRoute: WaitlistEmailPreviewRoute,WaitlistOutreachPreviewRoute: WaitlistOutreachPreviewRoute,ClaimClaimTokenRoute: ClaimClaimTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)